/* eslint-disable */
export function appDetails() {
    try {
        const ua = navigator.userAgent;
        let tem: any;
        let M: any =
            ua.match(
                /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
            ) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return { name: "IE", version: (tem[1] || undefined) as number };
        }
        if (M[1] === "Chrome") {
            tem = ua.match(/\bOPR|Edge\/(\d+)/);
            if (tem != null) {
                return { name: "Opera", version: tem[1] as number };
            }
        }
        M = M[2]
            ? [M[1], M[2]]
            : [navigator.appName, navigator.appVersion, "-?"];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) {
            M.splice(1, 1, tem[1]);
        }
        return {
            name: M[0],
            version: parseFloat(M[1])
        };
    } catch (e) {
        return {
            name: "",
            version: 0
        };
    }
}
